import { reloadWebsiteAfterLogin } from '../../utils/websiteVersion';

export function safeReturnTarget(value, fallback = '/home') {
  if (typeof value !== 'string' || !value.startsWith('/') || value.startsWith('//')) {
    return fallback;
  }

  try {
    const origin = typeof window === 'undefined' ? 'https://xiaoying.studio' : window.location.origin;
    const target = new URL(value, origin);
    if (target.origin !== origin) return fallback;
    return `${target.pathname}${target.search}${target.hash}`;
  } catch {
    return fallback;
  }
}

export function completeLogin({ token, navigate, returnTarget, user = null }) {
  if (typeof token !== 'string' || !token.trim()) {
    throw new Error('登录凭证无效');
  }

  localStorage.setItem('token', token.trim());
  window.dispatchEvent(new CustomEvent('auth-changed', { detail: { user } }));
  const target = safeReturnTarget(returnTarget);
  if (!reloadWebsiteAfterLogin(target)) navigate(target, { replace: true });
}
